import * as React from "react";
import { NativeTileShowcaseRegionProps, NativeTileShowcaseRegionFTNodeOptions } from "./typings";
import { Viewport, ViewSmall, ViewMedium, ViewLarge } from "@shared-ui/viewport-context";
import { BlossomComponents } from "components/flexFramework/BlossomComponents/BlossomComponents";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkSpacing } from "uitk-react-spacing";
import { observer } from "mobx-react";
import { withStores } from "stores";
import { normalizeOptionsData, hasRenderableChilren } from "src/stores/FlexTemplateStore";

export const NativeTileShowcaseRegion = withStores(
  "flexModuleModelStore",
  "context"
)(
  observer((props: NativeTileShowcaseRegionProps) => {
    const { context, blossomComponent, flexModuleModelStore, flexTemplateNode } = props;

    if (!blossomComponent) {
      return null;
    }

    const options = normalizeOptionsData(
      flexTemplateNode,
      flexModuleModelStore.getModel(flexTemplateNode.id)
    ) as NativeTileShowcaseRegionFTNodeOptions;

    const { mobileWidth, title, innerTitle, tabletWidth, desktopWidth } = options;

    if (!hasRenderableChilren(flexTemplateNode, flexModuleModelStore)) {
      return null;
    }

    const headingClass = "uitk-type-display-700 all-b-padding-zero uitk-cell all-cell-1-1 all-l-padding-zero";

    const titleContent = (
      <>
        {title && <h2 className={headingClass}>{title}</h2>}
        {innerTitle && <h2 className={headingClass}>{innerTitle}</h2>}
      </>
    );

    const flexContentDesktop = (
      <UitkSpacing margin={{ blockstart: "six", blockend: "three" }}>
        <div>
          {titleContent}
          <UitkLayoutFlex direction="row" wrap="nowrap" className="NativeTileShowcaseRegion">
            <BlossomComponents blossomComponent={blossomComponent} context={context} />
          </UitkLayoutFlex>
        </div>
      </UitkSpacing>
    );

    const flexContentNonDesktop = (
      <UitkSpacing margin={{ blockstart: "six", blockend: "three" }}>
        <div>
          {titleContent}
          <UitkLayoutFlex direction="column" space="six" wrap="wrap">
            <BlossomComponents blossomComponent={blossomComponent} context={context} />
          </UitkLayoutFlex>
        </div>
      </UitkSpacing>
    );

    return (
      <Viewport>
        {mobileWidth === "hidden" ? <ViewSmall /> : <ViewSmall>{flexContentNonDesktop}</ViewSmall>}

        {tabletWidth === "hidden" ? <ViewMedium /> : <ViewMedium>{flexContentNonDesktop}</ViewMedium>}

        {desktopWidth === "hidden" ? <ViewLarge /> : <ViewLarge>{flexContentDesktop}</ViewLarge>}
      </Viewport>
    );
  })
);

export default NativeTileShowcaseRegion;
